import React, { useState, useEffect } from 'react';

const words = [
  ['we', 'wind', 'us', 'none', 'echo'],
  ['will', 'must', 'are', 'suffer', 'done', 'alone', 'reject'],
  ['go', 'alarm', 'help', 'replaced by', 'neighter'],
  ['creature', 'wire', 'storm'],
];

function App() {
  const [wordsState, setWordsState] = useState(new Array(words.length).fill(0));

  const shuffleAround = () => {
    setWordsState(words.map((arr) => Math.floor(Math.random() * arr.length)));
  };

  useEffect(() => {
    const interval = setInterval(shuffleAround, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="index">
      {wordsState.map((wordId, id) => words[id][wordId]).join(' ')}
    </div>
  );
}

export default App;
